export const configCurrentBrand = process.env.REACT_APP_BRAND || 'Catalist'; // Default to Catalist if not set
export const configAppName = process.env.REACT_APP_NAME || 'CatalistPOS'; // Default to Catalist POS if not set
export const configCompanyName =
	process.env.REACT_APP_COMPANY_NAME || 'Catalist'; // Default to Catalist if not set
export const configSiteTitle =
	process.env.REACT_APP_SITE_TITLE || 'Catalist POS ERP'; // Default to Catalist POS ERP if not set
// export const configSiteLogo = 'assets/img/logo.png';
export const configSiteLogo = 'assets/img/brand/catalyst/logo.png';
// export const configSiteSideLogo = 'assets/img/logo.svg';
export const configSiteSideLogo = 'assets/img/brand/catalyst/side-logo.png';
// export const configSiteSmallLogo = 'assets/img/logo-small.png';
export const configSiteSmallLogo = 'assets/img/brand/catalyst/logo-small.png';
// export const configSiteWhiteLogo = 'assets/img/logo-white.svg';
export const configSiteWhiteLogo = 'assets/img/brand/catalyst/white-logo.png';
// export const configSiteSmallWhiteLogo = 'assets/img/logo-white-small.png';
export const configSiteSmallWhiteLogo =
	'assets/img/brand/catalyst/white-logo-small.jpg';
// export const configSiteFavIcon = '/assets/img/favicon.png';
export const configSiteFavIcon = 'assets/img/catalyst/favicon.png';

// const brandConfig = {
// 	Catalist: {
// 		logo: '/assets/img/catalist/logo/logo.png',
// 		primaryColor: '#FF5733',
// 		siteTitle: 'Catalist POS ERP',
// 	},
// 	Labaiq: {
// 		logo: '/assets/img/labaiq/logo/logo.png',
// 		primaryColor: '#3366FF',
// 		siteTitle: 'Labaiq POS ERP',
// 	},
// };

// // Ensure a valid brand is selected; if not found, default to Catalist
// const selectedBrandConfig =
// 	brandConfig[currentBrand] || brandConfig['Catalist'];

// export default selectedBrandConfig;
